import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import VueI18n from "vue-i18n";
import VueMoment from "vue-moment";
import FR from "./locale/fr.js";
import EN from "./locale/en.js";
import DE from "./locale/de.js";
import IT from "./locale/it.js";
import SV from "./locale/sv.js";
import PL from "./locale/pl.js";
import HU from "./locale/hu.js";
import "@/assets/style/main.css";
import "leaflet/dist/leaflet.css";
import store from "./store/index";
//import VueMatomo from 'vue-matomo'
import titleMixin from "./shared/titleMixin";
import Emitter from "tiny-emitter";
import VueCookies from "vue-cookies";
import "@mdi/font/css/materialdesignicons.css";
import VueExcelXlsx from "vue-excel-xlsx";
import axios from "axios";
import HorizontalTimeline from '@needahouse/vue-horizontal-timeline-component'

Vue.config.productionTip = false;
//Vue.prototype.$msalInstance = {};
Vue.prototype.$emitter = new Emitter();
Vue.prototype.$http = axios

Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.component('HorizontalTimeline', HorizontalTimeline)

Vue.mixin(titleMixin);
Vue.use(VueExcelXlsx);

/*Vue.use(VueMatomo, {
  host: "http://172.16.1.40/matomo/",
  siteId: 1,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
});*/

const moment = require("moment");
require("moment/locale/fr");
Vue.use(VueMoment, {
  moment,
});
const messages = {
  EN: EN,
  FR: FR,
  DE: DE,
  SV: SV,
  IT: IT,
  PL: PL,
  HU: HU,
};

const i18n = new VueI18n({
  locale: "EN",
  messages,
});

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
